import { useState, useEffect, useCallback } from 'react'

const STORAGE_KEY = 'secureblob-theme'

export type Theme = 'light' | 'dark'

/**
 * Theme hook — manages light/dark mode.
 * Default: light (falls back to system preference if no stored value).
 */
export function useTheme(): { theme: Theme; toggleTheme: () => void } {
    const [theme, setThemeState] = useState<Theme>(() => {
        const stored = localStorage.getItem(STORAGE_KEY)
        if (stored === 'dark' || stored === 'light') return stored
        // Default to light unless system prefers dark
        if (window.matchMedia?.('(prefers-color-scheme: dark)')?.matches) return 'dark'
        return 'light'
    })

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme)
        localStorage.setItem(STORAGE_KEY, theme)
    }, [theme])

    const toggleTheme = useCallback(() => {
        setThemeState(prev => prev === 'light' ? 'dark' : 'light')
    }, [])

    return { theme, toggleTheme }
}
